// Copyright (c) 2024 by Audere

import { Box, List, ListItem, Typography } from "@mui/material";
import { ErrorAlert, InfoAlert, WarningAlert } from "./Alerts";
import Message from "./Message";
import React from "react";
import { createStyleSheet } from "../utils/styles";
import { t } from "i18next";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import {
  GetConversationResponse,
  MessageData,
} from "../features/api/labelApiSlice";

interface MessagesProps {
  conversation?: GetConversationResponse;
  isLoading: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
}

const Messages: React.FC<MessagesProps> = ({
  conversation,
  isLoading,
  error,
}) => {

  if (isLoading) return <InfoAlert message="Loading messages..." />;
  if (error) return <ErrorAlert error={error} />;
  if (!conversation) return <WarningAlert message="No conversation found." />;

  return (
    <List aria-label="List of messages">
      {conversation.messages.map((message: MessageData) => (
        <ListItem key={message.message_uid}>
          <Message message={message} />
        </ListItem>
      ))}
      <Box sx={styles.listEndText}>
        <Typography variant="caption" color="textDisabled">
          {t("lists.endOfMsgs")}
        </Typography>
      </Box>
    </List>
  );
};

const styles = createStyleSheet({
  listEndText: {
    padding: 2,
    textAlign: "center",
    width: "100%",
  },
});
export default Messages;
